import { usePermission } from "./lib/permissions/hooks/usePermission";
import { PurplListAllUserMeasurementKey } from "./lib/permissions/keys";

export const useIsUserAdmin = () => {
  return usePermission(PurplListAllUserMeasurementKey);
};
